<template>
  <Dialog :title="titulo" v-model="dialog">

    <!-- Contenido -->
    <template v-slot:content>
      <p v-if="numero_tarjeta_credito">
        {{ $t('Actualmente está realizando los pagos con la tarjeta cuya numeración es:') }}
        <span class="subtitle-2">{{ numero_tarjeta_credito }}</span>
      </p>
      <span>{{
          $t('Para actualizar su tarjeta, se realizará un cargo de 0.10€ que será reembolsado automáticamente.')
        }}</span>
    </template>

    <!-- Botón de actualizar -->
    <template v-slot:left-action>
      <v-btn small class="success" dark @click="get_form">
        <v-icon small class="mr-2">mdi-credit-card-sync</v-icon>
        {{ $t('Actualizar tarjeta de crédito') }}
      </v-btn>
    </template>

  </Dialog>
</template>

<script>
export default {
  name: "DialogTarjetaCredito",

  props: ['value', 'titulo'],
  data: () => ({
    numero_tarjeta_credito: null
  }),

  computed: {
    dialog: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },

  methods: {
    /**
     * Recupera el número de la tarjeta de crédito
     * @returns {Promise<void>}
     */
    async get() {
      try {
        const response = await this.$store.dispatch("tarjeta_credito/get")
        this.numero_tarjeta_credito = response.numero;
      } catch {}
    },

    /**
     * Recupera el formulario para actualizar la tarjeta de crédito
     * @returns {Promise<void>}
     */
    async get_form() {
      const html_form = await this.$store.dispatch("tarjeta_credito/get_form_update_credit_card")
      document.body.innerHTML += html_form
      document.getElementById('addon_payments_form').submit()
      document.getElementById("addon_payments_form").remove()
    }
  },

  mounted() {
    // Recogemos los datos de la tarjeta de credito del centro
    this.get();
  }
};
</script>
